import { config } from "@/config";
import { LogBox } from "react-native";
import { noop } from "remeda";

export const configureLogger = () => {
  console.warn = noop;
  LogBox.ignoreLogs(config.reactNative.logBox.ignoreLogs);
};
